import {
  DARK_TEXT_COLOR,
  GREEN_BUTTON,
  GREY_BACKGROUND_LIGHT,
  GREY_BORDER,
  GREY_BORDER_LIGHT,
  GREY_BORDER_LIGHTER,
  WHITE_100,
} from '../../../theme';

/**
 * Shared styles for CreateDocumentModal and its sub-components.
 *
 * Only styles genuinely used across multiple components belong here.
 * Component-specific styles should be co-located in the component file.
 */
export const styles = {
  modal: {
    label: {
      color: DARK_TEXT_COLOR,
      fontSize: '0.875rem',
      fontWeight: '500',
      lineHeight: '140%',
    },
    radioCard: {
      disabledContainer: {
        alignItems: 'center',
        backgroundColor: GREY_BACKGROUND_LIGHT,
        border: `2px solid ${GREY_BORDER_LIGHT}`,
        borderRadius: '0.375rem',
        cursor: 'not-allowed',
        flex: 1,
        flexDirection: 'row',
        gap: '0.5rem',
        height: '2.5rem',
        justifyContent: 'flex-start',
        opacity: 0.5,
        paddingHorizontal: '1rem',
        paddingVertical: '0.25rem',
      },
      label: {
        color: DARK_TEXT_COLOR,
        fontSize: '0.875rem',
        fontWeight: '500',
        lineHeight: '140%',
      },
      radio: {
        '&.Mui-checked': {
          '& .MuiSvgIcon-root': {
            '&:last-child': {
              color: WHITE_100,
              // inner dot
              transform: 'scale(1.2)',
            },
          },
          backgroundColor: GREEN_BUTTON,
          borderColor: GREEN_BUTTON,
          borderRadius: '50%',
          color: GREEN_BUTTON,
          padding: 0,
        },
        color: GREY_BORDER_LIGHTER,
        padding: 0,
      },
      selectedContainer: {
        alignItems: 'center',
        backgroundColor: WHITE_100,
        border: `2px solid ${GREEN_BUTTON}`,
        borderRadius: '0.375rem',
        flex: 1,
        flexDirection: 'row',
        gap: '0.5rem',
        height: '2.5rem',
        justifyContent: 'flex-start',
        paddingHorizontal: '1rem',
        paddingVertical: '0.25rem',
      },
      unselectedContainer: {
        alignItems: 'center',
        backgroundColor: WHITE_100,
        border: `2px solid ${GREY_BORDER}`,
        borderRadius: '0.375rem',
        flex: 1,
        flexDirection: 'row',
        gap: '0.5rem',
        height: '2.5rem',
        justifyContent: 'flex-start',
        paddingHorizontal: '1rem',
        paddingVertical: '0.25rem',
      },
    },
    select: {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: GREEN_BUTTON,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: GREEN_BUTTON,
      },
      borderRadius: '0.5rem',
      height: '2.5rem',
    },
  },
};
